import React from "react";
import { Link } from "react-router-dom";
import {Heart, Mail, MapPin, Youtube, Linkedin, Shield, Lock, Facebook, DollarSign, ExternalLink} from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-[#1A202C] text-gray-300">
      <div className="container mx-auto px-4 py-6">
        {/* Brand Section - Compact */}
        <div className="text-center mb-6 pb-6 border-b border-gray-700">
          <div className="flex items-center justify-center space-x-2.5 mb-3">
            <Heart className="h-6 w-6 text-[#E53E3E] fill-current" />
            <div>
              <span className="text-xl font-bold text-white">Doe</span>
              <span className="block text-xs text-gray-400 -mt-0.5">ConectaVidas</span>
            </div>
          </div>
          <p className="text-xs text-gray-400 max-w-2xl mx-auto">
            Conectando doadores de sangue através de tecnologia e solidariedade
          </p>
        </div>

        {/* Main Footer Content - 3 Columns - More Compact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-5">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-3 flex items-center">
              <Heart className="h-3.5 w-3.5 text-[#E53E3E] mr-1.5" />
              Sobre Nós
            </h3>
            <p className="text-xs text-gray-400 leading-relaxed mb-3">
              Conectamos doadores voluntários a hospitais e pacientes em todo o Brasil
            </p>
            <div className="flex space-x-2 mt-3">
              <a
                href="https://www.youtube.com/@conectavidasapp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-gray-700 hover:bg-red-600 flex items-center justify-center transition-all hover:scale-110"
                aria-label="YouTube"
              >
                <Youtube className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61584539588383"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-gray-700 hover:bg-blue-600 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://x.com/conectavidasapp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-gray-700 hover:bg-black flex items-center justify-center transition-all hover:scale-110"
                aria-label="X (Twitter)"
              >
                <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/conectavidasapp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-gray-700 hover:bg-blue-700 flex items-center justify-center transition-all hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://www.tiktok.com/@conectadoadores"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-gray-700 hover:bg-black flex items-center justify-center transition-all hover:scale-110"
                aria-label="TikTok"
              >
                <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-3">Links Úteis</h3>
            <ul className="space-y-1.5 text-xs">
              <li>
                <Link to="/" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Início
                </Link>
              </li>
              <li>
                <Link to="/solicitacoes" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Solicitações Ativas
                </Link>
              </li>
              <li>
                <Link to="/sou-doador" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Cadastro de Doadores
                </Link>
              </li>
              <li>
                <Link to="/preciso-doar" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Criar Solicitação
                </Link>
              </li>
              <li>
                <Link to="/ranking" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Ranking de Heróis
                </Link>
              </li>
              <li>
                <Link to="/mapa" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Mapa Interativo
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Sobre o Projeto
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#E53E3E] transition-colors inline-block">
                  → Blog Educativo
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-3">Contato</h3>
            <ul className="space-y-2.5 text-xs">
              <li className="flex items-start space-x-2">
                <MapPin className="h-3.5 w-3.5 text-[#E53E3E] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium text-xs">Localização</p>
                  <p className="text-gray-400">Juiz de Fora – MG</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-3.5 w-3.5 text-[#E53E3E] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium text-xs">E-mail</p>
                  <a
                    href="mailto:luanalysson@gmail.com"
                    className="text-gray-400 hover:text-[#E53E3E] transition-colors"
                  >
                    luanalysson@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Shield className="h-3.5 w-3.5 text-[#E53E3E] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium text-xs">CNPJ</p>
                  <p className="text-gray-400">63.163.098/0001-18</p>
                </div>
              </li>
            </ul>

            {/* Security Badges - Smaller */}
            <div className="mt-3 flex flex-wrap gap-1.5">
              <div className="flex items-center space-x-1 bg-gray-700/50 px-2 py-1 rounded">
                <Lock className="h-3 w-3 text-green-400" />
                <span className="text-xs text-gray-300">Seguro</span>
              </div>
              <div className="flex items-center space-x-1 bg-gray-700/50 px-2 py-1 rounded">
                <Shield className="h-3 w-3 text-blue-400" />
                <span className="text-xs text-gray-300">LGPD</span>
              </div>
            </div>
          </div>
        </div>

        {/* Legal Links - More Compact */}
        <div className="border-t border-gray-700 pt-4 mb-4">
          <div className="flex flex-wrap justify-center gap-3 text-xs">
            <Link to="/politica-privacidade" className="hover:text-[#E53E3E] transition-colors">
              Política de Privacidade
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/termos-uso" className="hover:text-[#E53E3E] transition-colors">
              Termos de Uso
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/politica-privacidade" className="hover:text-[#E53E3E] transition-colors">
              LGPD
            </Link>
          </div>
        </div>

        {/* Bottom Footer - More Compact */}
        <div className="border-t border-gray-700 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0 text-xs text-gray-500">
            <p>
              © {new Date().getFullYear()} Doe ConectaVidas
            </p>
            <p className="text-center">
              Por <span className="text-white font-semibold">Luan Alysson de Souza</span>
            </p>
          </div>
          <div className="text-center mt-3">
            <a
              href="https://lumi.new/?via=luan"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-xs text-gray-500 hover:text-[#E53E3E] transition-colors"
            >
              Powered by <span className="ml-1 font-bold">Lumi</span> ⚡
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
